module.exports = __webpack_public_path__ + "img/nys-counties-transparent-2d26ec2c95c5a3bdd11e0c7ad7591719.2d26ec2c.png";